import { createContext } from "react";

const ContextComponent = createContext(null);

export default ContextComponent;
